import { MathUtils } from '@jumpstart/core';
import ajv, { ErrorObject } from 'ajv';


import jsonSourceMap from 'json-source-map';

const validator = new ajv({
  allErrors: true,  // do not bail, optional
  // jsonPointers: true,  // totally needed for this
});

const bucket = 'https://storage.googleapis.com/jumpstart-o5ofk';
const silhouettes = `${bucket}/silhouettes/breeds`;
// @TODO organize valid ids
export const RANDOM_DOG_IMAGE = (width: number = 750, height: number = 480) => `https://placedog.net/${width}/${height}?id=${MathUtils.randomInt(1, 100)}`
export const IMAGE_PLACEHOLDER = `${process.env.PUBLIC_URL}/assets/images/placeholder.png`;
export const PROFILE_PLACEHOLDER = `${process.env.PUBLIC_URL}/assets/images/profile_placeholder.svg`;
export const DOG_PROFILE_PLACEHOLDER = `${silhouettes}/medium-invert.svg`;
export const DOG_PROFILE_ANIMATED_PLACEHOLDER = `${process.env.PUBLIC_URL}/assets/images/gifs/dog1.gif`;

const animatedDogs = [
  `${process.env.PUBLIC_URL}/assets/images/gifs/dog1.gif`,
  `${process.env.PUBLIC_URL}/assets/images/gifs/dog2.gif`,
  `${process.env.PUBLIC_URL}/assets/images/gifs/dog3.gif`,
];
const defaultHumans = [
  `${process.env.PUBLIC_URL}/assets/profiles/unknown1.png`,
  `${process.env.PUBLIC_URL}/assets/profiles/unknown2.png`,
  `${process.env.PUBLIC_URL}/assets/profiles/unknown3.png`,
];
export const DEFAULT_DOG_GIF = () => animatedDogs[MathUtils.randomInt(0, animatedDogs.length - 1)];
export const DEFAULT_HUMAN_IMAGE = () => defaultHumans[MathUtils.randomInt(0, animatedDogs.length - 1)];

export const DEFAULT_DOG_IMAGES: { [name: string]: string } = {
  TOY: `${silhouettes}/toy-invert.svg`,
  SMALL: `${silhouettes}/small-invert.svg`,
  MEDIUM: `${silhouettes}/medium-invert.svg`,
  LARGE: `${silhouettes}/large-invert.svg`,
  GIANT: `${silhouettes}/giant-invert.svg`,
}

export const convertRange = (oldValue: number, oldMin: number, oldMax: number, newMin: number, newMax: number): number => {
  return (((oldValue - oldMin) * (newMax - newMin)) / (oldMax - oldMin)) + newMin;
}
export const lerp = (x: number, y: number, a: number) => x * (1 - a) + y * a;
export const clamp = (a: number, min: number = 0, max: number = 1) => Math.min(max, Math.max(min, a));
export const invlerp = (x: number, y: number, a: number) => clamp((a - x) / (y - x));
export const range = (x1: number, y1: number, x2: number, y2: number, a: number) => lerp(x2, y2, invlerp(x1, y1, a));

const value = (v: any, p: string[]): any => {
  if (p.length === 0) {
    return v;
  }
  const f: string | undefined = p.shift();
  if (f) {
    if (v.hasOwnProperty(f)) {
      return value(v[f], p);
    } else {
      throw new Error('Missing property');
    }
  } else {
    throw new Error('Failed to shift!');
  }
}

export const valueFromObj = (obj: any, path: string): any => {
  const fields: string[] = path.split('.');
  try {
    return value(obj, fields);
  } catch (err: any) {
    console.error(`Error getting object ${path}`, err.message);
    return null;
  }
}

export const assertJson = (schema: object | string | boolean, subject: any): (ErrorObject & { line: number })[] | null => {
  const valid = validator.validate(schema, subject);
  if (!valid) {
    const sourceMap = jsonSourceMap.stringify(subject, null, 2);
    if (!validator.errors) {
      return null;
    }
    if (!sourceMap) {
      return null
    }
    return validator.errors.reduce((accumulator: (ErrorObject & { line: number })[], error) => {
      const errorPointer = sourceMap.pointers[error.instancePath];
      accumulator.push({
        ...error,
        line: errorPointer.value.line
      });
      return accumulator;
    }, []);
  } else {
    return null;
  }
}

export const isPlaceholder = (img: string): boolean => (
  img.indexOf(`${process.env.PUBLIC_URL}/assets/profiles`) > -1
  || img.indexOf(silhouettes) > -1
  || img.indexOf('UNKNOWN') > -1
  || img.indexOf('placeholder') > -1
)
